import gql from 'graphql-tag'

export const examTaskAlgorithms = gql`
  query queriesAlgorithms {
      examTaskAlgorithms
  }
`
